<template>
    <div v-if="themeSetting('hide_territory_toggle') === 1" class="select-component" ref="selectComponent">
        <div :class="activeSelection" @click="showOptions = !showOptions" v-for="option in options" :key="option.id">
            <span v-if="option.id === territory">
                <img :src="asset(option.img)" :alt="option.alt" />
                <i :class="activeIcon"></i>
            </span>
        </div>
        <div class="toggle-list">
            <ul class="select-options" v-show="showOptions">
                <li v-for="option in options" :key="option" :value="option.id">
                    <a v-bind:href="option.url">
                        <img :src="asset(option.img)" :alt="option.alt" />
                        <small>{{ option.name }}</small>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TerritoryToggle',

    data: () => ({
        showOptions: false,
        activeIcon: 'fas fa-angle-down',
        activeSelection: '',
        options: [
            {
                id: 'aus',
                name: 'Australia',
                img: '/img/flags/aus-round.svg',
                url: 'https://www.monevo.com.au/',
                alt: 'AUS Flag',
            },
            {
                id: 'gbr',
                name: 'United Kingdom',
                img: '/img/flags/gbr-round.svg',
                url: 'https://www.monevo.co.uk/',
                alt: 'GBR Flag',
            },
            {
                id: 'usa',
                name: 'United States',
                img: '/img/flags/usa-round.svg',
                url: 'https://www.monevo.us/',
                alt: 'USA Flag',
            },
        ],
    }),

    watch: {
        showOptions: function (value) {
            if (value) {
                this.activeSelection = 'active-selection'
                this.activeIcon = 'fas fa-angle-left'
                document.addEventListener('click', this.closeIfClickedOutside)
            } else {
                this.activeSelection = ''
                this.activeIcon = 'fas fa-angle-left'
                document.removeEventListener('click', this.closeIfClickedOutside)
            }
        },
    },

    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
    },

    methods: {
        closeIfClickedOutside: function (event) {
            const closestElement = event.target.closest('.select-component')

            if (!closestElement || !closestElement.isSameNode(this.$refs.selectComponent)) {
                this.showOptions = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.toggle-list {
    position: absolute;
    width: 100%;
    top: 100%;
}
.active-selection {
    background-color: #ffffff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-inline-start: 1px solid #e0e1e5;
    position: absolute;
}
.select-options {
    background-color: #ffffff;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border: 1px solid #e0e1e5;
    bottom: 5.9%;
    position: absolute;
    transform: translate(0, 100%);
    width: 10%;

    @media screen and (min-width: $bp-medium) {
        left: -8% !important;
    }
    @media screen and (min-width: $bp-large) {
        left: -8% !important;
    }
    @media screen and (min-width: $bp-xl) {
        left: -8% !important;
    }

    li {
        background: #ffffff;
        font-size: rem(16px);
        margin-bottom: 1px;
        padding: 6px 10px;
        position: relative;

        &:hover {
            cursor: pointer;
        }
        small:hover {
            color: green;
        }
        small {
            color: black;
        }
    }
}
</style>
